import React, {useState, useEffect} from 'react';
import {Table, Button, Menu, Dropdown, Modal, Row, Col, message, Tooltip, Icon} from 'antd';
import { download, getStyleUrl, getUrl, style } from '../../../../util/image';
import { drawCanvas, uuid } from '../../../../util';
import Info from '../../../Detail/Info';

export const ALIGN_MAP = [
  {name:"左上", key:"nw", top:0, left:0},
  {name:"正上", key:"north", top:0, left:'50%'},
  {name:"右上", key:"ne", top:0, right:0},
  {name:"正左", key:"west", left:0, top:'50%'},
  {name:"正右", key:"east", right:0, top:'50%'},
  {name:"左下", key:"sw", bottom:0, left:0},
  {name:"正下", key:"south", bottom:0, left:'50%'},
  {name:"右下", key:"se", right:0, bottom:0},
  {name:"正中", key:"center", top:'50%', left:'50%'}
];

export const ADJUST_MAP = [
  {name:'横版', key:'h'},
  {name:'竖版', key:'v'}
];

/*
边距：[50, 40], 
水印：
[1089,264], [0.28, 0.10]
[376,373], [0.09， 0.14]
[902, 195], [0.23, 0.07]
[1950, 215], [0.50, 0.08]
[934, 279], [0.24, 0.10]
*/

const WatermarkEdit = (props)=>{
  const {id} = props.value;

  const [data, setData] = useState({
    id:uuid(6),
    align:'se',
    adjust:'h',
    percent:15,
    v:40,
    h:50
  });

  useEffect(()=>{
    if(props.value) {
      setData({
        ...data,
        ...props.value
      });
    }
  }, []);

  const onValueChange = (key, value)=>{
    setData({
      ...data,
      [key]:value
    });
  };

  return <Modal title={<span>{`${id ? `编辑` : `新增`}水印`} <small style={{color:`#d90000`}}>不支持含有渐变透明度的水印图片</small></span>} visible={true} centered={true} onOk={()=>{
    props.onSubmit && props.onSubmit(data);
  }} onCancel={()=>{
    props.onClose && props.onClose();
  }} maskClosable={false} width={690}>
    <Col>
      <Row>
        <Col span={12}>
          <Info label="图片" type="upload" value={data.icon} onChange={(e)=>onValueChange('icon', e)} />
        </Col>
        <Col span={12}>
          <Info label="适用版型" type="select" value={data.adjust} data={ADJUST_MAP} 
            onChange={(e)=>onValueChange('adjust', e)}
            tooltip={`1、“横版”则只会使用于横版图片及正方形图片，2、“竖版”则只会使用于竖版图片`} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Info label="水印位置" type="select" value={data.align} data={ALIGN_MAP} onChange={(e)=>onValueChange('align', e)} />
        </Col>
        <Col span={12}>
          <Info label="水印大小" type="number" step={1} min={1} max={100} value={data.percent} 
            onChange={(e)=>onValueChange('percent', e)}
            tooltip="水印大小是以水印占图片宽度的百分比来计算" />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Info label="水平间距" type="number" step={1} min={0} value={data.h} 
            onChange={(e)=>onValueChange('h', e)}
            tooltip="水平间距，是指水印距离图片最近一条垂直边的距离，仅在左上左中左下、右上右中右下位置时生效" />
        </Col>
        <Col span={12}>
          <Info label="垂直间距" type="number" step={1} min={0} value={data.v} 
            onChange={(e)=>onValueChange('v', e)}
            tooltip="垂直间距，是指水印距离图片最近一条水平边的距离，仅在左上正上右上、左下正下右下位置时生效" />
        </Col>
      </Row>
    </Col>
  </Modal>
};

const Watermarks = (props)=>{
  const [watermarks, setWatermarks] = useState([]);
  useEffect(()=>{
    if(props.value instanceof Array) {
      setWatermarks((props.value || []).map(it=>{
        if(!it.id) {
          it.id = uuid(6);
        }
        return it;
      }));
    }
  }, []);

  const onDelete = (item)=>{
    setWatermarks(watermarks.filter(it=>{
      if(item.id) {
        return it.id != item.id;
      }else {
        return it.icon != item.icon;
      }
    }));
  };

  useEffect(()=>{
    if(props.onChange) {
      props.onChange(watermarks);
    }
  }, [watermarks]);

  const previewTarget = (target)=>{
    const targets = {
      'h_dark':'source/45b0b28981623cc3d002d816bce115f5.jpg',
      'h_light':'source/190729/c0f61aed21dbda48c5efe1b61733f3c9.jpg',
      'v_dark':'attachment/8d52d3a1ffea9655fac4517ffbf3cc42.jpg',
      'v_light':'attachment/54f2ff3b57c13665c22b8fa1eb8ddf7e.jpg'
    }
    window.open(style(targets[target], 'wx_1920_n', {
      watermark:watermarks,
      width:100,
      targetWidth:1920,
      height:['h_dark', 'h_light'].indexOf(target) > -1 ? 50 : 150
    }));
  };

  const onSetPercentAuto = async ()=>{
    const hide = message.loading('正在处理中', 0);
    const H_WIDTH = 3840;
    const H_HEIGHT = 2560;
    // 拟定 横图模式下，水印图高度占比约为10%，知水印图的 width 和 height，反推横向占比，得出等效宽度
    let datas = [
      ...watermarks
    ];

    const getCalSize = (adjust, width, height)=>{
      width = Number(width);
      height = Number(height);
      const P = 0.1;

      // 先放大图片
      let targetWidth = 0;
      let targetHeight = 0;
      let percent = P;

      if(adjust == 'h') {
        const hPercent = H_WIDTH / width;
        const vPercent = H_HEIGHT / height;

        // 水印放大后，短边到顶了
        if(vPercent < hPercent) {
          targetHeight = H_HEIGHT * P;
          targetWidth = width * vPercent * P;
        }else {
          targetWidth = H_WIDTH * P;
          targetHeight = height * hPercent * P;
        }
      }
      if(adjust == 'v') {
        const hPercent = H_HEIGHT / width;
        const vPercent = H_WIDTH / height;

        // 水印放大后，短边到顶了
        if(vPercent < hPercent) {
          targetHeight = H_WIDTH * P;
          targetWidth = width * vPercent * P;
        }else {
          targetWidth = H_HEIGHT * P;
          targetHeight = height * hPercent * P;
        }
      }

      if(targetWidth > targetHeight) {
        if(targetHeight < H_HEIGHT * P) {
          const scale = H_HEIGHT * P / targetHeight;
          percent = P * scale;
        }
      }
      else if(targetWidth <= targetHeight) {
        if(targetWidth < H_HEIGHT * P) {
          const scale = H_HEIGHT * P / targetWidth;
          percent = P * scale;
        }
      }

      return {
        width:Math.round(targetWidth),
        height:Math.round(targetHeight),
        percent:Math.round(percent * 100)
      };

      // let dic = width / height;
      // if(dic >= 0.9 && dic <= 1.1) {
      //   return {
      //     width:(adjust == 'h' ? H_WIDTH : H_HEIGHT) * P,
      //     height:(adjust == 'h' ? H_WIDTH : H_HEIGHT) * P
      //   };
      // }
      // let targetHeight = H_HEIGHT * P;
      // let percent = targetHeight / height;
      // let targetWidth = Math.round(width * percent);
      // return {
      //   width:targetWidth,
      //   height:targetHeight
      // }
    };

    // 先处理横版
    for(let i=0;i<datas.length;i++) {
      let one = datas[i];
      const dimension = await window.fetch(getStyleUrl(one.icon) + `?x-oss-process=image/info`).then(res=>{
        return res.json();
      });
      const {width, height, percent} = getCalSize(one.adjust, dimension.ImageWidth.value, dimension.ImageHeight.value);

      // 水印的短边，对应着原图的长边做缩放
      one.percent = percent;
      datas[i] = one;
    }
    // 再处理竖版，竖版要根据横版的等效高等计算
    // for(let i=0;i<datas.length;i++) {
    //   let one = datas[i];
    //   if(one.adjust == 'v') {
    //     // 找到模版图
    //     const dimension = await window.fetch(getStyleUrl(one.icon) + `?x-oss-process=image/info`).then(res=>{
    //       return res.json();
    //     });
    //     const {width, height} = getCalSize(dimension.ImageWidth.value, dimension.ImageHeight.value);
    //     if(width > height) {
    //       one.percent = Math.round(width * 100 / H_HEIGHT);
    //     }else {
    //       one.percent = Math.round(width * 100 / H_WIDTH);
    //     }
    //   }
    //   datas[i] = one;
    // }

    setWatermarks(datas);
    hide();
    message.success('自动设置完成');
  };

  const onSetVerticalAuto = ()=>{
    let allWatermarks = [
      ...watermarks
    ];
    watermarks.forEach(it=>{
      // 要找不到对应的竖版
      const exist = watermarks.find(one=>{
        if(one.align == it.align) {
          if(one.adjust == 'v') {
            return true;
          }
        }
        return null;
      });

      if(!exist) {
        allWatermarks.push({
          ...it,
          id:uuid(6),
          adjust:'v'
        });
      }
    });

    setWatermarks(allWatermarks);
  };

  const downloadFullSize = async ()=>{
    const hide = message.loading('正在生成中', 0);

    const watermarkH = drawCanvas(3840, 2560);
    const adjustH = watermarks.filter(it=>it.adjust == 'h');
    if(adjustH && adjustH.length) {
      for(let i=0;i<adjustH.length;i++) {
        await watermarkH.appendWatermark(adjustH[i]);
      }
    }

    download(watermarkH.build('image/png'), `全尺寸水印_横版_${props.id}.png`);

    const watermarkV = drawCanvas(2560, 3840);
    const adjustV = watermarks.filter(it=>it.adjust == 'v');
    if(adjustV && adjustV.length) {
      for(let i=0;i<adjustV.length;i++) {
        await watermarkV.appendWatermark(adjustV[i]);
      }
    }

    download(watermarkV.build('image/png'), `全尺寸水印_竖版_${props.id}.png`);

    // const fullsizeWatermark = [
    //   `attachment/999ca6a731f85b5bad5a46ad5b2b6d2b.png`,
    //   `attachment/4ef71af0b0a73e263c7edc399bba9d6b.png`
    // ];

    // download(style(fullsizeWatermark[0], 'watermark_h', {
    //   watermark:watermarks,
    //   targetWidth:3840,
    //   width:3840,
    //   height:2560,
    // }), `全尺寸水印_横版_${props.id}.png`);

    // download(style(fullsizeWatermark[1], 'watermark_v', {
    //   watermark:watermarks,
    //   targetWidth:3840,
    //   width:2560,
    //   height:3840,
    // }), `全尺寸水印_竖版_${props.id}.png`);

    hide();
  };

  const [edit, setEdit] = useState(null);

  return <div className="dp-f j-c a-c">
    <div className="flex1 dp-f" style={{"marginRight": "20px", "marginBottom": "10px"}}>
      <div className="label">水印设置<Tooltip title="最多添加三个位置的水印"><Icon type="question-circle" /></Tooltip></div>
      <div className="value flex1">
        <Table rowKey="id" columns={[
          {title:"图片", dataIndex:'icon', render:(val)=>{
            return val ? <div className="avatar-uploader" onClick={()=>{
              window.open(`${style(val, 'original')}`);
            }}>
              <img className="avatar" src={getStyleUrl(val, 'thumb_150')} />
            </div> : '--';
          }},
          {title:"适用", dataIndex:'adjust', render:(val)=>{
            let exist = ADJUST_MAP.find(it=>it.key == val);
            return exist ? exist.name : '--';
          }},
          {title:"位置", dataIndex:'align', render:(val)=>{
            let exist = ALIGN_MAP.find(it=>it.key == val);
            return exist ? exist.name : '--';
          }},
          {title:"占比", dataIndex:'percent', render:(val)=>`${val}%`},
          {title:"边距", dataIndex:"h", render:(val, record)=>{
            return `(${record.h || 0},${record.v || 0})`;
          }},
          {title:'操作', dataIndex:'id', render:(val, record)=>{
            return <Dropdown.Button overlay={<Menu>
              <Menu.Item onClick={()=>{
                setEdit(record);
              }}>编辑</Menu.Item>
              <Menu.Item onClick={()=>{
                download(getUrl(record.icon), `水印_${record.id}.png`);
              }}>下载</Menu.Item>
              <Menu.Item onClick={()=>onDelete(record)}>移除</Menu.Item>
            </Menu>}>
              操作
            </Dropdown.Button>
          }}
        ]} dataSource={watermarks} footer={()=>{
          return <React.Fragment>
              <Button onClick={()=>{
                setEdit({});
              }} style={{marginRight:10}}>上传新水印</Button>
              <Dropdown.Button style={{marginRight:10}} overlay={<Menu>
                <Menu.Item onClick={onSetVerticalAuto}>自动补全竖版</Menu.Item>
                <Menu.Item onClick={onSetPercentAuto}>自动设置比例</Menu.Item>
              </Menu>}>
                自动设置
              </Dropdown.Button>
              <Dropdown.Button style={{marginRight:10}} overlay={<Menu>
                <Menu.Item onClick={()=>previewTarget('h_dark')}>横版深色</Menu.Item>
                <Menu.Item onClick={()=>previewTarget('h_light')}>横版浅色</Menu.Item>
                <Menu.Item onClick={()=>previewTarget('v_dark')}>竖版深色</Menu.Item>
                <Menu.Item onClick={()=>previewTarget('v_light')}>竖版浅色</Menu.Item>
              </Menu>}>
                预览效果
              </Dropdown.Button>
              <Button onClick={props.resetWatermark} style={{marginRight:10}}>重置拼图</Button>
              <Button onClick={downloadFullSize}>全尺寸水印</Button>
            </React.Fragment>
        }} pagination={false} />
      </div>
    </div>
    {edit ? <WatermarkEdit value={edit} onSubmit={(values)=>{
      if(values && values.icon) {
        // 判断一下，在指定位置，是否已经有内容了
        const existAlign = watermarks.find(it=>{
          if(it.align == values.align) {
            if(it.adjust == values.adjust) {
              if(it.id != values.id) {
                return true;
              }
            }
          }
          return false;
        });

        if(existAlign) {
          return Modal.error({
            title:'水印位置设置错误',
            content:`当前水印位置，已有其他水印图占据，如需显示在同一位置，请尝试将两个水印图合并为一个水印图`
          });
        }

        let existAlignMap = {
          [values.align]:true
        };
        watermarks.forEach(it=>{
          existAlignMap[it.align] = true
        });
        if(Object.keys(existAlignMap).length > 3) {
          return Modal.error({
            title:'水印数量错误',
            content:`最多设置三个位置的水印图片，超出数量则会导致图片无法显示`
          });
        }

        if(edit && edit.id) {
          setWatermarks(watermarks.map(it=>{
            if(it.id == edit.id) {
              return values;
            }
            return it;
          }));
        }else {
          setWatermarks([
            ...watermarks,
            values
          ]);
        }
        setEdit(null);
      }else {
        message.error('水印图片为必选项');
      }
    }} onClose={()=>{
      setEdit(null);
    }} /> : null}
  </div>
};

export default Watermarks;


// WEBPACK FOOTER //
// ./src/components/FileViewerV2/page/tree/watermark.js